module Meevo.Plugins.DrawerManager {
    "use strict";

    export class DrawerHistorySection extends Meevo.Plugins.DrawerManager.DrawerManagerSectionBase {

        private All: string = "All";

        public criteria: Model.DrawerHistoryCriteria = {
            drawerId: null,
            drawerState: this.All,
            startDate: null,
            endDate: null,
            location: null,
            includeActive: true,
            includeInactive: false,
            includeDeleted: false,
            paymentTypeId: this.getPaymentTypeCash()
        };
        public columns: any[] = [];
        public drawerStates: any[] = [];
        public drawerId: any = this.All;
        public allDrawers: any[];
        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
        canViewCalculatedCash: boolean = true;

        constructor(drawerManagerContext: Meevo.Plugins.DrawerManager.DrawerManagerContext,
            protected dataService: Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected printService: Meevo.Components.Common.IPrintService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            private $translate: angular.translate.ITranslateService,
            private $filter: angular.IFilterService,
            personalHeader: boolean,
            personalFooter: boolean,
            protected $q: angular.IQService,
            protected securityService: Meevo.Components.Common.ISecurityService) {

            super(DrawerManager.DrawerManagerSectionTypeEnum.DrawerHistory, drawerManagerContext, "drawerHistory", personalHeader, personalFooter);

            this.createColumns();
            securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.REGISTER_DRAWERMANAGER_ACTION_VIEWEXPECTEDCLOSINGTOTALS).then(result => {
                this.canViewCalculatedCash = result === Model.SecurityAccessEnum.Grant;
            });

            this.dataService.getEnumList(Meevo.Model.EnumTypeEnum.DrawerStateEnum)
                .then((data: any) => {
                    this.drawerStates = data;
                });

            if (this.context.paymentTypes == undefined) {
                this.context.getAllPaymentTypes().then(() => {
                    this.criteria.paymentTypeId = this.getPaymentTypeCash()
                });
            }
        }

        reset() {
            let preservedCriteria = this.$rootScope.drawerHistorySearchCriteria;
            super.reset();
            if (preservedCriteria && !this.context.insideRegister) {
                this.criteria = preservedCriteria;
                this.drawerId = (this.criteria.drawerId ? this.criteria.drawerId : this.All);
            }
            else {
                this.criteria = this.getGenericCriteria();
                this.drawerId = this.All;
            }
        }

        initialize(drawerId: string, criteria?: Model.DrawerHistoryCriteria) {
            //page renders using this.getDefaultCriteria(), so it needs to be set earlier. next lines promise fulfills after default criteria calls
            if (drawerId != null) {
                this.criteria.drawerId = drawerId;
            }
            if (criteria != null) {
                this.criteria = _.clone(criteria);
            }
            this.getDrawers().then(() => {
                if (drawerId != null && _.findWhere(this.context.getDrawerList(), { id: drawerId })) {
                    this.drawerId = drawerId;
                    this.drawerChange();
                }
            });
        }

        getDrawers() {
            let defer = this.$q.defer();
            if (!this.allDrawers && !this.context.isApplicationModeCO()) {
                this.allDrawers = [];
                this.context.getAllDrawer().then((drawers) => {
                    this.allDrawers = drawers;
                    defer.resolve();
                });
            }
            else {
                defer.resolve();
            }
            return defer.promise;
        }

        getSectionName() {
            return "Drawer History";
        }

        getState(): any {
            return { criteria: this.criteria, drawerId: this.drawerId };
        }

        setState(state: any) {
            if (state != null) {
                if (state.criteria != null) {
                    this.criteria.drawerId = state.criteria.drawerId;
                    this.criteria.startDate = state.criteria.startDate;
                    this.criteria.endDate = state.criteria.endDate;
                    this.criteria.location = state.criteria.location;
                    if (state.criteria.drawerState) {
                        this.criteria.drawerState = state.criteria.drawerState;
                    }
                    this.criteria.includeActive = true;
                    this.criteria.paymentTypeId = state.criteria.paymentTypeId;
                }
                if (state.drawerId) {
                    this.drawerId = state.drawerId;
                    this.drawerChange();
                }
            }
        }

        createColumns() {
            this.columns = [
                { header: "Opened", fieldName: 'openedDate', filter: 'drawerManagerDate', sortDirection: null, width: 20 },
                { header: "Closed", fieldName: 'closedDate', filter: 'drawerManagerDate', sortDirection: null, width: 20 },
                { header: "Drawer Name", fieldName: 'drawerDisplayName', sortDirection: null, width: 20 },
                { header: "Open", fieldName: 'openCashAmount', filter: 'meevoCurrency', sortDirection: null, width: 10 },
                { header: "Over/Short", fieldName: 'totalOverShort', filter: 'meevoCurrency', sortDirection: null, width: 10 },
                { header: "Opened By", fieldName: 'openedByDisplayName', sortDirection: null, width: 10 },
                { header: "Closed By", fieldName: 'closedByDisplayName', sortDirection: null, width: 10 }
            ];
        }

        getDisplayData(item, column) {
            if (column.filter) {
                return this.$filter(column.filter)(item[column.fieldName]);
            }
            return item[column.fieldName];
        }

        getMaxEndDate() {
            let today = moment().startOf("day");
            //if (_.isDate(this.criteria.startDate)) {
            //    let maxDate = moment(this.criteria.startDate).startOf("day").add(7, "days");
            //    if (maxDate.isAfter(today)) {
            //        return today;
            //    }
            //    return maxDate;
            //}
            return today;
        }

        getDefaultCriteria() {
            return this.criteria;
        }

        getGenericCriteria(drawerId?: string): Model.DrawerHistoryCriteria {
            let criteria: Model.DrawerHistoryCriteria = {
                drawerId: drawerId ? drawerId :null,
                drawerState: this.All,
                startDate: moment().startOf("day").add(-7, "days").toDate(),
                endDate: moment().startOf("day").toDate(),
                location: null,
                includeActive: true,
                includeInactive: false,
                includeDeleted: false,
                paymentTypeId: this.getPaymentTypeCash()
            };
            return criteria;
        }

        drawerChange() {
            if (this.drawerId == this.All) {
                this.criteria.drawerId = null;
            }
            else {
                this.criteria.drawerId = this.drawerId;
            }
            this.storeCriteria();
        }

        startDateChanged() {
            this.storeCriteria();
        }
        drawerStateChange() {
            this.storeCriteria();
        }
        endDateChanged() {
            this.storeCriteria();
        }
        storeCriteria() {
            if (!this.context.insideRegister) {
                this.$rootScope.drawerHistorySearchCriteria = this.criteria;
            }
        }

        locationChange() {
            let locationId = (this.criteria.location != null ? this.criteria.location.id : null);
            if (this.context.isApplicationModeCO() && locationId == null) {
                this.allDrawers = [];
            }
            else {
                this.context.getAllDrawer(locationId).then((drawers) => {
                    this.allDrawers = drawers;
                });
            }
        }

        showDrawerSessionItem(item) {
            if (!this.context.isApplicationModeCO()) {
                this.context.showDrawerSessionInfo(item.drawerId, item.id);
            }
        }

        preApplyFilter() {
            if (this.context.isApplicationModeCO()) {
                if (this.criteria.location == null) {
                    this.modalService.alert("Please select a location first.");
                    return false;
                }
            }
            return true;
        }

        printDepositSlip(item) {
            var options = {
                url: `/api/Drawer/${item.drawerId}/Session/${item.id}/DepositSlip`,
                method: 'GET',
                params: {
                    locale: this.appSettings.APP_COUNTRYID,
                    timeFormat: this.appSettings.APP_TIME_FORMAT,
                    languageDictionary: {
                        'LABEL_CHECK_DEPOSIT': this.$translate.instant('LABEL_CHECK_DEPOSIT'),
                        'LABEL_CHECK_DETAIL': this.$translate.instant('LABEL_CHECK_DETAIL'),
                    },
                }
            };
            this.printService.printCustom(options);
        }

        showNotes(item) {
            this.context.getGenericDrawerSession(item.drawerId, true, item.id).then((data) => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/drawerManager/modals/noteView.template.html",
                    controller: "meevo.plugins.drawerManager.DrawerManagerController",
                    controllerAs: "vm",
                    bindToController: true,
                    locals: {
                        drawerSessionItem: {
                            openingNote: this.getNote(data.notes, Meevo.Model.DrawerStateEnum.Open),
                            closingNote: this.getNote(data.notes, Meevo.Model.DrawerStateEnum.Close)
                        }
                    }
                }
                this.modalService.showCustom(options);
            });
        }
        getNote(notes: any[], type: Meevo.Model.DrawerStateEnum) {
            let note = _(notes).where({ drawerState: type });
            return (note && note.length > 0 && note[0].note);
        }

        getPaymentTypeCash() {
            const paymentType = _.findWhere(this.context.paymentTypes, { paymentCategory: Meevo.Model.PaymentCategoryEnum.Cash });
            if (paymentType) {
                return paymentType.id;
            }
            return null;
        }
    }
}